// =============================================================================
// MHV CONFIG — Central configuration for Memory Hole Vintage auction system
// Must be loaded BEFORE any other MHV scripts (Socket.IO, host-main, etc.)
// =============================================================================

(function() {
  'use strict';

  var MHV = window.MHV || {};

  // Single source of truth for server URL
  MHV.SERVER_URL = 'https://mhv-viewer-app-1df0c0c61ed9.herokuapp.com';

  // Convenience API URL builder
  MHV.apiUrl = function(path) {
    return MHV.SERVER_URL + path;
  };

  // Shared getDeviceInfo — browser/OS/device detection
  // (Previously duplicated in main-host.liquid, live.liquid, chat-widget.liquid, chat-section.liquid)
  MHV.getDeviceInfo = function() {
    var ua = navigator.userAgent || '';

    // Detect browser
    var browser = 'Unknown';
    var browserVersion = '';
    if (ua.indexOf('Firefox') > -1) {
      browser = 'Firefox';
      browserVersion = (ua.match(/Firefox\/(\d+(\.\d+)?)/) || [])[1] || '';
    } else if (ua.indexOf('Edg/') > -1) {
      browser = 'Edge';
      browserVersion = (ua.match(/Edg\/(\d+(\.\d+)?)/) || [])[1] || '';
    } else if (ua.indexOf('Chrome') > -1 && ua.indexOf('Safari') > -1) {
      browser = 'Chrome';
      browserVersion = (ua.match(/Chrome\/(\d+(\.\d+)?)/) || [])[1] || '';
    } else if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
      browser = 'Safari';
      browserVersion = (ua.match(/Version\/(\d+(\.\d+)?)/) || [])[1] || '';
    } else if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1) {
      browser = 'IE';
      browserVersion = (ua.match(/(?:MSIE |rv:)(\d+(\.\d+)?)/) || [])[1] || '';
    } else if (ua.indexOf('Opera') > -1 || ua.indexOf('OPR') > -1) {
      browser = 'Opera';
      browserVersion = (ua.match(/(?:Opera|OPR)\/(\d+(\.\d+)?)/) || [])[1] || '';
    }

    // Detect OS
    var os = 'Unknown';
    var osVersion = '';
    if (ua.indexOf('Windows NT 10') > -1) {
      os = 'Windows'; osVersion = '10/11';
    } else if (ua.indexOf('Windows NT 6.3') > -1) {
      os = 'Windows'; osVersion = '8.1';
    } else if (ua.indexOf('Windows NT 6.2') > -1) {
      os = 'Windows'; osVersion = '8';
    } else if (ua.indexOf('Windows NT 6.1') > -1) {
      os = 'Windows'; osVersion = '7';
    } else if (ua.indexOf('Mac OS X') > -1) {
      os = 'macOS';
      var macMatch = ua.match(/Mac OS X (\d+[._]\d+([._]\d+)?)/);
      if (macMatch) osVersion = macMatch[1].replace(/_/g, '.');
    } else if (ua.indexOf('iPhone') > -1 || ua.indexOf('iPad') > -1) {
      os = ua.indexOf('iPad') > -1 ? 'iPadOS' : 'iOS';
      var iosMatch = ua.match(/OS (\d+[._]\d+([._]\d+)?)/);
      if (iosMatch) osVersion = iosMatch[1].replace(/_/g, '.');
    } else if (ua.indexOf('Android') > -1) {
      os = 'Android';
      var androidMatch = ua.match(/Android (\d+(\.\d+)?)/);
      if (androidMatch) osVersion = androidMatch[1];
    } else if (ua.indexOf('CrOS') > -1) {
      os = 'ChromeOS';
    } else if (ua.indexOf('Linux') > -1) {
      os = 'Linux';
    }

    // Detect device type
    var deviceType = 'Desktop';
    if (ua.indexOf('Mobile') > -1 || ua.indexOf('iPhone') > -1 || (ua.indexOf('Android') > -1 && ua.indexOf('Mobile') > -1)) {
      deviceType = 'Mobile';
    } else if (ua.indexOf('iPad') > -1 || ua.indexOf('Tablet') > -1 || (ua.indexOf('Android') > -1 && ua.indexOf('Mobile') === -1)) {
      deviceType = 'Tablet';
    }

    return {
      deviceType: deviceType,
      os: os + (osVersion ? ' ' + osVersion : ''),
      browser: browser,
      browserVersion: browserVersion,
      screenSize: screen.width + 'x' + screen.height,
      language: navigator.language || 'Unknown'
    };
  };

  window.MHV = MHV;
})();
